import { Approval } from "./Approval";
import { Authorization } from "./Authorization";
import { Benefits } from "./Benefits";
import { BenefitsStatus } from "./BenefitsStatus";
import { CallInfo } from "./CallInfo";
import { CallLog } from "./CallLog";
import { CarveOutCombo } from "./CarveoutCombo";
import { CodeSetMatch } from "../../../../modules/verification/specs/codeSets/ProcedureCodeSetMatch";
import { ComboOfBenefitsIssue } from "./ComboOfBenefitsIssue";
import { DiagnosisCodes } from "./DiagnosisCodes";
import { DrgCombo } from "./DrgCombo";
import { EstimatedProcedure } from "./EstimatedProcedure";
import { Note } from "./Note";
import { PatientResponsibility } from "./PatientResponsibility";
import { PreQuoteAttributes } from "./PreQuoteAttributes";
import { SingleCaseAgreement } from "./SingleCaseAgreement";
import { VerificationDocument } from "./VerificationDocument";
import { VerifyAttributes } from "./VerifyAttributes";
import { WaystarAuthStatus } from "./WaystarAuthStatus";

export class Verification{
    public id: string = '';
    public center: string = '';
    public accountNumber: string = '';
    public approval:Approval = new Approval();
    public benefits: Benefits = new Benefits();
    public callInfo: CallInfo = new CallInfo();
    public authorization: Authorization = new Authorization();
    public benefitsStatus: BenefitsStatus = new BenefitsStatus();
    public patientResponsibility: PatientResponsibility = new PatientResponsibility();
    public diagnosisCodes: DiagnosisCodes = new DiagnosisCodes();
    public procedures: EstimatedProcedure[] = [];
    public notes:Note[] = [];
    public calls:CallLog[] = [];
    public documents:VerificationDocument[] = [];
    public waystarAuthStatus: WaystarAuthStatus = new WaystarAuthStatus();
    public singleCaseAgreement?: SingleCaseAgreement = new SingleCaseAgreement();
    public implantsNotUsed: boolean = false;
    public verifyAttributes: VerifyAttributes = new VerifyAttributes();
    public preQuoteAttributes: PreQuoteAttributes = new PreQuoteAttributes();
    public drgCombo: DrgCombo = new DrgCombo();
    public carveOutCombos: CarveOutCombo[] = [];
    public codeSetMatches: CodeSetMatch[] = [];
    public comboOfBenefitsIssue: ComboOfBenefitsIssue = new ComboOfBenefitsIssue();
    public preServiceCodingReviewComplete: boolean = false;
    public disableCodeSetMatching: boolean = false;
    public firstName: string = '';
    public lastName: string = '';
    public birthDate?: string;
    public serviceDate?: string;
    public admissionType: string = '';
    public primaryPayerId: string = '';
    public primaryPayerName: string = '';
}